import React from 'react';

// === Components === //
import Container from '@components/common/Container';
import ImageFull from '@components/common/ImageFull';
import Accordion from '@components/common/Accordion';

// === Helpers === //
import get from 'lodash.get';
import * as utils from '@utils';

// === Styles === //
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { breakpoints, colors, respondFrom, respondTo } from '@styles';

// === Types === //
import { Variant } from '@content/types/layout';
import { PageSectionComponent } from '@content/types/page';

const DesktopView = styled.div`
  display: none;

  ${respondFrom(
    breakpoints.md,
    css`
      display: block;
    `
  )}
`;

const MobileView = styled.div`
  display: none;

  ${respondTo(
    breakpoints.md,
    css`
      display: block;
    `
  )}
`;
const SymptomsAccordionBody = styled.div`
  > div {
    ul {
      list-style: none;
      padding-left: 0;
      margin-bottom: 0;

      li {
        position: relative;
        padding-left: 16px;
        color: ${colors.ui.accordionSymptomsTitle};

        &::before {
          content: '';
          position: absolute;
          top: 7px;
          left: 3px;
          width: 3px;
          height: 3px;
          border-radius: 100%;
          background-color: ${colors.ui.hcpDefault};
        }
      }
    }
  }
`;

interface SymptomsData {
  variant: Variant;
  data: PageSectionComponent;
}

const Symptoms = ({ data, variant }: SymptomsData) => {
  return (
    <Container>
      <>
        <DesktopView>
          <ImageFull
            imageDesktop={get(data, 'fieldIcon.entity.url', '')}
            alt={get(data, 'fieldIcon.alt')}
            title={get(data, 'fieldIcon.title', '')}
          />
        </DesktopView>
        <MobileView>
          {get(data, 'fieldInfo', []).map((item, index) => (
            <Accordion
              variant={variant}
              icons={{
                open: get(item, 'entity.fieldIcon.entity.url', ''),
                close: get(item, 'entity.fieldSymptomIcon.entity.url', ''),
              }}
              key={index}
              title={get(item, 'entity.fieldTitle', '')}
              id={`accordion-${index}`}
              preExpanded={[`accordion-0`]}
              type="symptoms"
            >
              <SymptomsAccordionBody>
                {utils.SafeHtml(get(item, 'entity.fieldLongText.processed', ''))}
              </SymptomsAccordionBody>
            </Accordion>
          ))}
        </MobileView>
      </>
    </Container>
  );
};

export default Symptoms;
